<template>
    <div :class="['page about',{ off: !pageOn }]">
        <VHeader type="back" @back="pageOn = false;" />
        <div class="page-content">
            <img class="page-image" src="/about.png" />
        </div>  
    </div>
</template>

<script>

import VHeader from '@/components/VHeader.vue'
import { pageOn } from '@/utils/pageOn.js'

export default {
    name: 'about',
    mixins: [ pageOn ],
    components: {
        VHeader
    },
    
}

</script>

<style>

</style>